import React, { useEffect, useRef, useState } from 'react'
import useStateRef from 'react-usestateref'
import { Link } from 'react-router-dom';
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';

const OrderSummary = (props) => {

    const [orderSummaryDetails, setOrderSummaryDetails, orderSummaryDetailsRef] = useStateRef();
    const [search, setSearch, searchRef] = useStateRef("");
    const [showTooltip, setShowTooltip] = useState(false);
    const [showTooltip1, setShowTooltip1] = useState(false);
    const [showRemovePromoCode, setshowRemovePromoCode, showRemovePromoCodeRef] = useStateRef(false);
    const [errorPromo, setErrorPromo, errorPromoRef] = useStateRef(false);
    const [PromotionalCodeErrorMsg, setPromotionalCodeErrorMsg, PromotionalCodeErrorMsgRef] = useStateRef()
    const [isSticky, setIsSticky] = useState(false);
    const orderSummaryRef = useRef(null);
    const [disable, setDisable, disableRef] = useStateRef(false);
    const [errorMsg, setErrorMsg, errorMsgRef] = useStateRef(false);
    const promoRef = useRef(null);
    const [scrollPosition, setScrollPosition, scrollPositionRef] = useStateRef('')
    const [topPosition, setTopPosition, topPositionRef] = useStateRef(true);

    useEffect(() => {
        setSearch(window.location.pathname)
        if (props.orderSummaryDetails) {
            setOrderSummaryDetails(props.orderSummaryDetails);
        }
        if (searchRef.current == "/checkout/review") {
            // document.getElementById("submit-order-div").classList.remove("d-none");
            document.getElementById("submit-order-div").classList.add("d-md-block");
        } else {
            document.getElementById("submit-order-div").classList.remove("d-md-block");
            document.getElementById("submit-order-div").classList.add("d-none");
        }
    }, [props.orderSummaryDetails])

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };
    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    const handleMouseEnter1 = () => {
        setShowTooltip1(true);
    };
    const handleMouseLeave1 = () => {
        setShowTooltip1(false);
    };

    async function handlePromoCode(event) {
        event.preventDefault()
        setErrorPromo(false);
        setPromotionalCodeErrorMsg();
      
        var data = new FormData(event.target);
        var promoCode = data.get("promoCode");
        if (promoCode == "" || promoCode == null) {
            setErrorMsg(true)
            setErrorPromo(true);
        } else {
            
            document.getElementById("promotional-code-submit-summary").disabled = true;
            var actionUrl = "api/rest/cb/cart/apply-promo-code";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                actionType: "applyCouponCode",
                couponId: promoCode
            }))
            document.getElementById("promotional-code-submit-summary").disabled = false;
            if (res.result === "success") {
                setErrorMsg(false)
                setErrorPromo(false);
                setshowRemovePromoCode(true)
                if ((JSON.parse(res.response)) && (JSON.parse(res.response)).errorMessage &&
                (JSON.parse(res.response)).errorMessage[0] &&
                (JSON.parse(res.response)).errorMessage[0].message) {
                setPromotionalCodeErrorMsg((JSON.parse(res.response)).errorMessage[0].message)
            }
                props.handleCallBackOrderSummary()

            } else {
                setErrorMsg(false);
                setErrorPromo(true);
                setshowRemovePromoCode(true)
                setPromotionalCodeErrorMsg((JSON.parse(res.response)).errorMessage[0].message)
                props.handleCallBackOrderSummary()
            }
        }

    }

    async function handleRemovePromoCode() {
        document.getElementById("promotional-code-submit-summary").disabled = true;
        setErrorPromo(false);
        const promotionCode = document.getElementById("promotionalCode").value
        var actionUrl = "api/rest/cb/cart/remove-promo-code";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            actionType: "removeCouponCode",
            couponId: promotionCode
        }))
        document.getElementById("promotional-code-submit-summary").disabled = false;
        if (res.result == "success") {
            setshowRemovePromoCode(false)
            setPromotionalCodeErrorMsg()
            props.handleCallBackOrderSummary()
            promoRef.current.reset()
             
        } else {
            setshowRemovePromoCode(true)
        }

    }

    const handleScroll = () => {
        const element = orderSummaryRef.current;
        const visibleElement = document.querySelector('#visibleElement');
        if (visibleElement) {
            const position = visibleElement.getBoundingClientRect();
            setScrollPosition(position);
            setTopPosition(false);
            if (position.top >= 0) {
                setIsSticky(false);
                element.style.width = "";
                element.style.left = "";
            } else if (position.top < 0 && window.matchMedia("(min-width: 768px)").matches) {
                const width = element.offsetWidth;
                const left = element.getBoundingClientRect().left;
                setIsSticky(true);
                element.style.width = `${width}px`;
                element.style.left = `${left}px`;
            }
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleSubmitOrder = (event) => {
        props.handleSubmitOrder(event)
    }

    return (
        <div ref={orderSummaryRef} className={`col-12 col-md-4 my-order-section my-summery-view ${isSticky ? 'order-fix' : ''}`} id="orders1" >
            <div className='c-shipping-box'>
                <div className="row g-3 mb-3 d-none " id="submit-order-div">
                    <div className="col-md-12 d-grid">
                        <button type="submit" className="btn btn-primary block" tabindex="7" onClick={handleSubmitOrder}>Submit Order</button>
                    </div>
                </div>
                <div className="row g-0 mb-40">
                    <div className="col-4 col-md-4">
                        <h2 className="c-shipping-order-title">My Order</h2>
                    </div>
                    <div className="col-3 col-md-3">
                        (<span className="c-shipping-order-item">
                            {orderSummaryDetailsRef.current && orderSummaryDetailsRef.current.commerceItemCount}
                        </span>
                        {(orderSummaryDetailsRef.current && orderSummaryDetailsRef.current.commerceItemCount === 1) ?
                            " item" : " items"}
                        )
                    </div>
                    <div className="col-5 col-md-5 text-end">
                        <Link className="c-shipping-order-edit" to="/checkout/cart">edit shopping cart</Link>
                    </div>
                </div>

                <form id="orderSummary" method="POST" onSubmit={handlePromoCode} ref={promoRef} >
                    {!orderSummaryDetailsRef.current?.restrictPromotion ?
                        <div className="row g-2 mb-2">
                        <div className="col-7 col-md-7">
                            <label className="form-label form-hipping-label" for="promotionalCode">
                                Apply a Promotional Code
                            </label>
                            
                            <input type="text" name="promoCode" className={`form-control ${errorPromoRef.current == true ? "quantity-error" : ""}`} id="promotionalCode" placeholder="enter promo code" defaultValue={orderSummaryDetailsRef.current && orderSummaryDetailsRef.current.discountId ? orderSummaryDetailsRef.current.discountId:"" } />

                            {(showRemovePromoCodeRef.current == true || orderSummaryDetailsRef.current && orderSummaryDetailsRef.current.discountId ) && errorMsgRef.current == false ?
                                <p className=" orderSummaryRemoveCode c-shipping-order-remove promotional-code-remove fw-normal mb-0" onClick={handleRemovePromoCode} style={{ cursor: 'pointer' }}>
                                    remove code
                                </p> : ""}

                        </div>

                        <div className="col-5 col-md-5 text-end">
                            <input name="applyCodeBtn" type="submit"  id="promotional-code-submit-summary" value={`${orderSummaryDetailsRef.current && orderSummaryDetailsRef.current.discountId && errorPromoRef.current == false ? "change code" : "apply code"}`} className="btn btn-secondary block c-shipping-btn" />
                        </div>
                    </div>:<></>}
                </form>
                {errorPromoRef.current == true && errorMsgRef.current == true ?
                    <p className="error error-promotion" >
                        You did not enter a promotion code.
                    </p> : ""
                }
                {/* {showRemovePromoCodeRef.current == true || orderSummaryDetailsRef.current && orderSummaryDetailsRef.current.discountId ?
                    <button className="c-shipping-order-remove promotional-code-remove fw-normal" onClick={() => handleRemovePromoCode()}>
                        remove code
                    </button> : ""} */}
                {!props.isOrderSummaryLoading && orderSummaryDetailsRef.current ?
                <>
                 {orderSummaryDetailsRef.current.discountMessage || PromotionalCodeErrorMsgRef.current ? 
                <div className="c-promotion-code-height">

                    <div className="row justify-content-center promotional-code-messaging messaging">
                        <div className="col-12 col-md-12 messageDiv">
                            {orderSummaryDetailsRef.current && orderSummaryDetailsRef.current.discountMessage && !PromotionalCodeErrorMsgRef.current ?
                            <p className="c-success text-center">
                                {orderSummaryDetailsRef.current.discountMessage}
                            </p>
                            :""}
                            <p  className={`c-error text-center ${PromotionalCodeErrorMsgRef.current ? " d-block" : ""}`} dangerouslySetInnerHTML={{ __html: PromotionalCodeErrorMsgRef.current }}></p>
                            
                        </div>
                    </div>
                </div>
                 :<></>} 

                
                    <div id="order-summary">
                        <div className="loader-image">
                            <div className="c-order-summary">
                                <p className="c-order-label">Subtotal:</p>
                                <p className="c-order-value">{orderSummaryDetailsRef.current.subTotal}</p>
                            </div>
                            {orderSummaryDetailsRef.current.discountAmount ?
                                <div className="c-order-summary">
                                    <p className="c-order-label">Promotional Discount:</p>
                                    <p className="c-order-value c-order-discount">- {orderSummaryDetailsRef.current.discountAmount}</p>
                                </div> : ""}
                            <div className="c-order-summary">
                                <p className="c-order-label" style={{ display: 'flex' }}>
                                    {orderSummaryDetailsRef.current.shippingLabel}
                                    <span className="c-tooltip" onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                        style={{
                                            position: 'relative'
                                            // , marginRight: '-30px', padding: '5px' 
                                        }}>
                                        <i className="bi bi-question-circle-fill"></i>
                                        {showTooltip && orderSummaryDetailsRef.current.reviewShipToolTip && (
                                            <div
                                                style={scrollPositionRef.current ?.top > 114 || topPositionRef.current?{
                                                    position: 'absolute',
                                                    top: '-318px',
                                                    left: '-90px',
                                                    background: '#fbf3bf',
                                                    padding: '0.875rem',
                                                    zIndex: '1',
                                                    width: '200px',
                                                    border: '0.063rem solid #ccc',
                                                    boxShadow: '0 0 0.625rem #ccc',
                                                    fontSize: '0.75rem',
                                                    lineHeight: '1.125rem',
                                                    letterSpacing: '0',
                                                    color: '#333',
                                                    borderRadius: '0.313rem',
                                                    textAlign: 'left'
                                                }:{  position: 'absolute',
                                                top: '-85px',
                                                left: '28px',
                                                background: '#fbf3bf',
                                                padding: '0.875rem',
                                                zIndex: '1',
                                                width: '200px',
                                                border: '0.063rem solid #ccc',
                                                boxShadow: '0 0 0.625rem #ccc',
                                                fontSize: '0.75rem',
                                                lineHeight: '1.125rem',
                                                letterSpacing: '0',
                                                color: '#333',
                                                borderRadius: '0.313rem',
                                                textAlign: 'left'}}
                                            >
                                                 {/* <div className='tooltip-arrow'></div> */}
                                                <div className='tooltip-arrow' style={scrollPositionRef.current?.top > 114  || topPositionRef.current?{
                                                    position: 'absolute',
                                                    top: '311px',
                                                    left: '47%',
                                                    marginLeft: '0px',
                                                    width: '0',
                                                    height: '0',
                                                    borderLeft: '5px solid transparent',
                                                    borderRight: '5px solid transparent',
                                                    borderTop: '7px solid #333',
                                                }:{
                                                    position: 'absolute', top: '90px', left: '4%', marginLeft: '-15px', width: '0', height: '0',
                                                    borderTop: '5px solid transparent', borderBottom: '5px solid transparent', borderRight: '7px solid #333',
                                                }}></div>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: orderSummaryDetailsRef.current.reviewShipToolTip }}
                                                ></div>
                                            </div>
                                        )}
                                    </span>
                                    {/* <button type="button"  className="c-tooltip" data-bs-toggle="tooltip" data-bs-html="true" title={orderSummaryDetailsRef.current.reviewShipToolTip}   ><i className="bi bi-question-circle-fill"></i></button>
                                  */}
                                </p>
                                <p className="c-order-value">
                                    <del>{orderSummaryDetailsRef.current && orderSummaryDetailsRef.current.nonContractShippingTotal ? orderSummaryDetailsRef.current.nonContractShippingTotal : ""}  </del>
                                    {orderSummaryDetailsRef.current.shippingTotal}
                                </p></div>
                            <div className="c-order-summary">
                                <p className="c-order-label">
                                    {orderSummaryDetailsRef.current.taxLabel}
                                    <span className="c-tooltip" onMouseEnter={handleMouseEnter1}
                                        onMouseLeave={handleMouseLeave1}
                                        style={{
                                            position: 'relative'
                                        }}
                                    >
                                        <i className="bi bi-question-circle-fill"></i>
                                        {showTooltip1 && orderSummaryDetailsRef.current.reviewTaxToolTip && (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '-78px',
                                                    left: '-90px',
                                                    zIndex: '1',
                                                    width: '200px',
                                                    padding: '0.875rem',
                                                    backgroundColor: '#fbf3bf',
                                                    border: '0.063rem solid #ccc',
                                                    boxShadow: '0 0 0.625rem #ccc',
                                                    fontSize: '0.75rem',
                                                    lineHeight: '1.125rem',
                                                    letterSpacing: '0',
                                                    color: '#333',
                                                    borderRadius: '0.313rem',
                                                    textAlign: 'left'
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: '65px',
                                                        left: '47%',
                                                        marginLeft: '0px',
                                                        width: '0',
                                                        height: '0',
                                                        borderLeft: '5px solid transparent',
                                                        borderRight: '5px solid transparent',
                                                        borderTop: '7px solid #333',
                                                    }}
                                                ></div>{orderSummaryDetailsRef.current.reviewTaxToolTip}
                                            </div>
                                        )}
                                    </span>

                                </p>
                                <p className="c-order-value">
                                    {orderSummaryDetailsRef.current.tax}
                                </p>
                            </div>


                            <div className="mt-4">
                                {orderSummaryDetailsRef.current.totalRetailLabel ?
                                    <>
                                        <div className="c-order-summary">
                                            <p className="c-order-label">{orderSummaryDetailsRef.current.totalRetailLabel}</p>
                                            <p className="c-order-value"><del>{orderSummaryDetailsRef.current.totalRetail}</del></p>
                                        </div>
                                        <div className="c-order-summary">
                                            <p className="c-order-total">
                                                <span className='nonContractLable'>{orderSummaryDetailsRef.current.orderTotalLabel}</span>
                                            </p>
                                            <p className="c-order-amount">
                                                {orderSummaryDetailsRef.current.orderTotal}
                                            </p>
                                        </div>
                                    </> :
                                    <div className="c-order-summary">
                                        <p className="c-order-total">
                                            {orderSummaryDetailsRef.current.orderTotalLabel}
                                        </p>
                                        <p className="c-order-amount">
                                            {orderSummaryDetailsRef.current.orderTotal}
                                        </p>
                                    </div>}

                            </div>
                        </div>
                    </div> 
                    </>
                    :
                    <div className="loadingAnimation d-block" id='loading-spinner'>
                        <span className="spinner-border" role="status" aria-hidden="true"></span>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                }
            </div>
            <div className="c-shipping-guest">
                <i className="bi bi-lock-fill"></i>
                <span>
                    Secure Checkout Shopping is always safe and secure
                </span>
            </div>
        </div >
    )
}

export default OrderSummary
